var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit3 = function SvgEdit3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.759 2a3.243 3.243 0 0 1 2.292 5.533L8.488 20.098c-.251.25-.552.443-.882.566l-.144.048-4.098 1.243a1.058 1.058 0 0 1-1.32-1.317l.001-.002 1.243-4.097c.119-.388.331-.74.617-1.026L16.467 2.949A3.24 3.24 0 0 1 18.759 2m1.712 17.884a.589.589 0 1 1 0 1.176h-7.53a.588.588 0 1 1 0-1.176zM18.759 3.176c-.48 0-.941.167-1.309.468l-.151.136L4.738 16.345c-.15.15-.262.333-.325.535h.001l-1.178 3.885 3.884-1.18c.203-.06.388-.17.537-.32L20.22 6.7a2.065 2.065 0 0 0-1.46-3.525"
  })));
};
export default SvgEdit3;